// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._16jlkb7n{flex-grow:1}\n._18m915vq{overflow-y:hidden}\n._1bto1l2s{text-overflow:ellipsis}\n._1o9zkb7n{flex-shrink:1}\n._1reo15vq{overflow-x:hidden}\n._1ul953f4{min-width:75pt}\n._1ul9idpf{min-width:0}\n._4cvr1h6o{align-items:center}\n._bozgu2gc{padding-inline-start:var(--ds-space-100,8px)}\n._i0dl1osq{flex-basis:100%}\n._o5721q9c{white-space:nowrap}\n._p12f1osq{max-width:100%}\n._syaz1fxt{color:var(--ds-text,#172b4d)}\n._vwz419ii{line-height:1.4}", ""]);
// Exports
module.exports = exports;
